import { defineMessages } from "@/i18n";
import en from "./en";

export const releaseChannelMessages = defineMessages("release-channel", en);
